import { FlowConfiguration } from "../../rule-engine-core/Flow/FlowConfiguration";
import { FormStep } from "../../rule-engine-core/Flow/Steps/UI/FormStep";
import { LogStep } from "../../rule-engine-core/Flow/Steps/General/LogStep";
import { MultiOutputTestStep } from "../../rule-engine-core/Flow/Steps/ExampleSteps/MultiOutputTestStep";
import { FlowStepSequence } from "../../rule-engine-core/Flow/Structure/FlowStepSequence";
import { FlowStepOutputInstructionType } from "../../rule-engine-core/Flow/Structure/FlowStepOutputInstructions";
import { CandidateSequence } from "../../rule-engine-core/Flow/Structure/CandidateSequence";
import { FlowSequenceCompleteStrategy } from "../../rule-engine-core/Flow/Structure/FlowSequenceCompleteStrategy";

export function getFlowWithSteps(): FlowConfiguration {
    let flow = new FlowConfiguration();
    let step = new FormStep();
    step.name = "Form";
    flow.allSequences[0].addStep(step);
    flow.allSequences[0].addStep(new MultiOutputTestStep());
    flow.allSequences[0].addStep(new LogStep());
    return flow;
}

export function getFlowWithNoSteps(): FlowConfiguration {
    let flow = new FlowConfiguration();
    return flow;
}

export function getFlowWithEndOrError(): FlowConfiguration {
    let flow = new FlowConfiguration();
    flow.endSequence.addStep(new FormStep());
    flow.endSequence.addStep(new LogStep());

    flow.errorSequence.addStep(new FormStep());
    flow.errorSequence.addStep(new LogStep());
    return flow;
}

export function getFlowWithMultipleSequences(): FlowConfiguration {
    let flow = new FlowConfiguration();
    let primaryMultiStep = new MultiOutputTestStep();

    flow.allSequences[0].addStep(new FormStep());
    flow.allSequences[0].addStep(primaryMultiStep);
    flow.allSequences[0].addStep(new LogStep());

    let newSeq = new FlowStepSequence();
    newSeq.name = "Test 1";
    newSeq.desiredX = 500;
    newSeq.desiredY = 100;

    let newStep = new MultiOutputTestStep();
    let secondPathForNewStep = newStep.getOutcomeInstructions()[1];
    secondPathForNewStep.strategy = FlowStepOutputInstructionType.BRANCH;
    let candidate = new CandidateSequence(secondPathForNewStep);
    secondPathForNewStep.connectedSequenceId = candidate._id;

    newSeq.addStep(newStep);
    newSeq.addStep(new MultiOutputTestStep());
    flow.addSequence(newSeq);

    let newSeq1 = new FlowStepSequence();
    newSeq1.name = "Test 2";
    newSeq1.desiredX = 500;
    newSeq1.desiredY = 100;
    newSeq1.strategy = FlowSequenceCompleteStrategy.LINK;

    newSeq1.addStep(new MultiOutputTestStep());
    flow.addSequence(newSeq1);

    // multiple output step
    let multipleStep = flow.allSequences[0].steps[1];
    // set sencond path as branch and connect it to new sequence, first path is continue.
    let secondPathForMultipleStep = multipleStep.getOutcomeInstructions()[1];
    secondPathForMultipleStep.strategy = FlowStepOutputInstructionType.BRANCH;
    secondPathForMultipleStep.connectedSequenceId = newSeq._id;

    let thirdPathForMultipleStep = multipleStep.getOutcomeInstructions()[2];
    thirdPathForMultipleStep.strategy = FlowStepOutputInstructionType.BRANCH;
    thirdPathForMultipleStep.connectedSequenceId = newSeq1._id;

    return flow;
}

export function getFlowWithBranch() {
    let flow = new FlowConfiguration();
    flow.allSequences[0].strategy = FlowSequenceCompleteStrategy.LINK;

    return flow;
}
